import React from 'react';
import { PreviewWithList } from 'components/common';
import { EmailList } from 'components/pages/email-page-template/preview/email-list-dropdown';
import { EmailPreview } from './EmailPreview';

interface EmailPreviewWithListProps {
  showList: boolean;
  showPreview: boolean;
  isLoading: boolean;
  selectedEmailId?: number;
  selectedEmailSubject?: string;
  streaming?: boolean;
  payload: object;
  isDropdownOpen: boolean;
  onEmailSelect: (emailThreadId: number, email: any) => void;
  onBack: () => void;
}

export const EmailPreviewWithList: React.FC<EmailPreviewWithListProps> = ({
  showList,
  showPreview,
  isLoading,
  selectedEmailId,
  selectedEmailSubject,
  streaming,
  payload,
  isDropdownOpen,
  onEmailSelect,
  onBack,
}) => {
  return (
    <PreviewWithList
      showList={showList}
      showPreview={showPreview}
      listComponent={
        <EmailList
          isLoading={isLoading}
          handleMenuClick={onEmailSelect}
          selectedEmailId={selectedEmailId}
          isDropdownOpen={isDropdownOpen}
          showSearch={true}
          alwaysEnablePagination
        />
      }
      previewComponent={
        selectedEmailId &&
        selectedEmailSubject && (
          <EmailPreview
            streaming={streaming}
            emailThreadId={selectedEmailId}
            emailSubject={selectedEmailSubject}
            payload={payload}
            onBack={onBack}
          />
        )
      }
    />
  );
};
